import { useState } from 'react';
import BoardList from './BoardList';
// import BoardWrite from './BoardWrite';
import BoardDetail from './BoardDetail';
import Menu from '../../components/menu/Menu';
import styled from 'styled-components';
import PageTop from '../../components/pageTop/PageTop';

const Board = () => {
  const [boardType, setBoardType] = useState<string>('List');
  const [openMenu, setOpenMenu] = useState(false);
  const [articleData, setArticleData] = useState<any>([]);
  const [articleidx, setArticleidx] = useState<number>(0);

  const boardContent = () => {
    if (boardType === 'List') {
      return (
        <BoardList setBoardType={setBoardType} setArticleidx={setArticleidx} />
      );
    }
    //  else if (boardType === 'Write') {
    //   return <BoardWrite setBoardType={setBoardType} mode="create" />;
    // } else if (boardType === 'Edit') {
    //   return (
    //     <BoardWrite
    //       setBoardType={setBoardType}
    //       detailData={articleData}
    //       mode="edit"
    //     />
    //   );
    // }
    else if (boardType === 'Detail') {
      return (
        <BoardDetail
          setBoardType={setBoardType}
          articleidx={articleidx}
          setArticleData={setArticleData}
        />
      );
    } else {
      return <></>;
    }
  };

  return (
    <Container>
      <PageTop text={'고객센터'} setOpenMenu={setOpenMenu} />

      {openMenu && <Menu page="main" setOpenMenu={setOpenMenu} />}
      {boardContent()}
    </Container>
  );
};

export default Board;

// const Container = styled.div`
//   width: 100%;
//   font-family: Spoqa Han Sans Neo;
// `;

const Container = styled.div`
  max-width: 900px;
  min-height: 100vh;
  margin: 0 auto;
  box-shadow: 0 0 20px hsla(0, 0%, 51%, 0.15);
  position: relative;
  font-family: Spoqa Han Sans Neo;
  display: flex;
  flex-direction: column;
`;
const Inner = styled.div`
  width: 100%;
  /* padding: 24px 16px 40px; */
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  flex-grow: 1;
`;
const Content = styled.div`
  flex: 1;
  display: flex;
  flex-direction: row;
  justify-content: center;
`;
// const Inner = styled.div`
//   width: 1200px;
//   display: flex;
//   flex-direction: column;
// `;
const PageTitle = styled.div`
  width: 100%;
  text-align: left;
  font-family: Spoqa Han Sans Neo;
  font-size: 24px;
  font-weight: 700;
  color: #171e26;
`;
